<template>
  <div>
    <footer class="footer bg-[#131419] relative text-violet-100 dark:text-violet-100">
      <div class="container border-t border-[#4e4e53]">
        <div class="grid grid-cols-12">
          <div class="col-span-12">
            <div class="py-[40px] px-0">
              <div class="grid grid-cols-1">
                <ul class="list-none footer-list text-left mt-8 md:flex">
                  <div class="flex-1">
                    <img src="../assets/images/astrowarp-logo_white.svg" class="hidden dark:inline-block logo" alt="" />
                    <p class="text-[16px] pt-4 text-[#ffffff]">
                      Flexible and Secure Networking Solutions.
                    </p>
                  </div>
                  <div class="flex-1 md:pl-32 text-[#ffffff] item">
                    <li class="text-[#ffffff50] font-bold">Shop</li>
                    <li class="mt-[10px] ">
                      <router-link to="/shop"
                        class=" hover:text-gray-400 duration-500 ease-in-out">Pricing</router-link>
                    </li>
                    <li class="mt-[10px]">
                      <router-link to="/shop/compatible-devices"
                        class=" hover:text-gray-400 duration-500 ease-in-out">Compatible Devices</router-link>
                    </li>
                  </div>

                  <div class="flex-1  text-[#ffffff] item">
                    <li class="text-[#ffffff50] font-bold">Resources</li>
                    <li class="mt-[10px]">
                      <a target="_blank" href="https://docs.astrowarp.net/"
                        class=" hover:text-gray-400 duration-500 ease-in-out">Docs</a>
                    </li>
                    <li class="mt-[10px]">
                      <router-link to="/security-notice" class=" hover:text-gray-400 duration-500 ease-in-out">Security
                        Notice</router-link>
                    </li>
                    <li class="mt-[10px]">
                      <router-link to="/privacy-policy" class=" hover:text-gray-400 duration-500 ease-in-out">Privacy
                        Policy</router-link>
                    </li>
                    <li class="mt-[10px]">
                      <router-link to="/service-agreement" class=" hover:text-gray-400 duration-500 ease-in-out">User
                        Service Agreement</router-link>
                    </li>
                  </div>

                  <div class="flex-1 item">
                    <div class="flex flex-col">
                      <div class="flex-1">
                        <h5 class="text-lg dark:dark:text-[#ffffff50] mb-2 font-bold">
                          Email
                        </h5>
                        <a href="mailto:support@astrowarp.net" class="text-white">support@astrowarp.net</a>
                      </div>
                      <div class="flex-1 item1">
                        <h5 class="text-lg dark:text-[#ffffff50] mb-2 font-bold">
                          Location
                        </h5>
                        <p class="text-white mb-2">
                          GL Intelligence, Inc.<br />
                          10400 Eaton Place, Suite 215, <br />
                          Fairfax, VA 22030
                        </p>
                      </div>
                    </div>
                  </div>
                </ul>
                <!--end icon-->
              </div>
              <!--end grid-->
            </div>
          </div>
        </div>
        <!--end grid-->

      </div>
      <div class="container border-t border-[#4e4e53]">
        <div class="pb-[30px] pt-2  w-full">
          <div class="text-center">
            <div style="flex-direction: column;" class="flex  lg:flex-row justify-between items-center">
              <div class="md:text-start text-center">
                <p class="text-[#939393]">
                  © {{ date }} AstroWarp. Powered by
                  <a href="https://gl-inet.com" target="_blank" class="text-reset">GL.iNet</a>.
                </p>
              </div>
              <ul class="list-none text-left">
                <li class="inline pr-2">
                  <a href="https://www.reddit.com/r/AstroWarp/" target="_blank"
                    class="inline-flex text-white/60 items-center text-center justify-center text-base font-normal tracking-wide align-middle transition duration-500 ease-in-out">
                    <svg class="text-white/60" viewBox="0 0 1024 1024" width="28" height="28">
                      <path
                        d="M938.666667 490.666667A106.666667 106.666667 0 0 0 832 384a104.96 104.96 0 0 0-64 22.613333A486.4 486.4 0 0 0 551.68 341.333333l26.453333-151.466666a10.24 10.24 0 0 1 10.24-8.96h2.986667L725.333333 221.866667a85.333333 85.333333 0 1 0 17.92-61.44l-134.826666-39.253334a85.333333 85.333333 0 0 0-20.906667-2.986666 74.666667 74.666667 0 0 0-73.386667 61.866666L486.826667 341.333333A491.52 491.52 0 0 0 256 406.613333 104.96 104.96 0 0 0 192 384 106.24 106.24 0 0 0 128 576.853333 165.546667 165.546667 0 0 0 128 597.333333c0 141.226667 170.666667 256 384 256s384-114.773333 384-256a165.546667 165.546667 0 0 0 0-20.48 106.666667 106.666667 0 0 0 42.666667-86.186666z m-640 42.666666A64 64 0 1 1 362.666667 597.333333 64 64 0 0 1 298.666667 533.333333z m350.293333 189.44a21.76 21.76 0 0 1-10.666667 13.653334 268.373333 268.373333 0 0 1-252.586666 0 21.76 21.76 0 0 1-10.666667-13.653334 22.186667 22.186667 0 0 1 3.413333-17.066666l12.373334-17.493334A20.906667 20.906667 0 0 1 418.133333 682.666667a216.32 216.32 0 0 0 187.733334 0 20.906667 20.906667 0 0 1 27.306666 6.826666l12.373334 17.493334a22.186667 22.186667 0 0 1 3.413333 15.786666zM661.333333 597.333333a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                        class="index-svg"></path>
                    </svg>
                  </a>
                </li>

                <li class="inline">
                  <a href="https://link.gl-inet.com/AW-homepage-discord" target="_blank"
                    class="inline-flex items-center text-center justify-center text-base font-normal tracking-wide align-middle transition duration-500 ease-in-out">
                    <svg viewBox="0 0 1280 1024" width="24" height="24">
                      <path
                        d="M1049.062 139.672a3 3 0 0 0-1.528-1.4A970.13 970.13 0 0 0 808.162 64.06a3.632 3.632 0 0 0-3.846 1.82 674.922 674.922 0 0 0-29.8 61.2 895.696 895.696 0 0 0-268.852 0 619.082 619.082 0 0 0-30.27-61.2 3.78 3.78 0 0 0-3.848-1.82 967.378 967.378 0 0 0-239.376 74.214 3.424 3.424 0 0 0-1.576 1.352C78.136 367.302 36.372 589.38 56.86 808.708a4.032 4.032 0 0 0 1.53 2.75 975.332 975.332 0 0 0 293.65 148.378 3.8 3.8 0 0 0 4.126-1.352A696.4 696.4 0 0 0 416.24 860.8a3.72 3.72 0 0 0-2.038-5.176 642.346 642.346 0 0 1-91.736-43.706 3.77 3.77 0 0 1-0.37-6.252 502.094 502.094 0 0 0 18.218-14.274 3.638 3.638 0 0 1 3.8-0.512c192.458 87.834 400.82 87.834 591 0a3.624 3.624 0 0 1 3.848 0.466 469.066 469.066 0 0 0 18.264 14.32 3.768 3.768 0 0 1-0.324 6.252 602.814 602.814 0 0 1-91.78 43.66 3.75 3.75 0 0 0-2 5.222 782.11 782.11 0 0 0 60.028 97.63 3.728 3.728 0 0 0 4.126 1.4A972.096 972.096 0 0 0 1221.4 811.458a3.764 3.764 0 0 0 1.53-2.704c24.528-253.566-41.064-473.824-173.868-669.082zM444.982 675.16c-57.944 0-105.688-53.174-105.688-118.478s46.818-118.482 105.688-118.482c59.33 0 106.612 53.64 105.686 118.478 0 65.308-46.82 118.482-105.686 118.482z m390.76 0c-57.942 0-105.686-53.174-105.686-118.478s46.818-118.482 105.686-118.482c59.334 0 106.614 53.64 105.688 118.478 0 65.308-46.354 118.482-105.688 118.482z"
                        class="index-svg"></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--end footer-->
    <!-- Footer End -->
  </div>
</template>

<script>
export default {
  name: "footerVue",
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
  mounted() {
    this.scrollToTop();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>

.footer-list .item1 {
    margin-top: 30px;
  }
@media (max-width: 767px) {
  .footer-list .item,.footer-list .item1 {
    margin-top: 30px;
  }
}
.index-svg {
  fill: #ffffff90;
}

.index-svg:hover {
  fill: #ffffff;
}

ul li {
  margin-inline-start: 0px;
}
</style>